import { HOUR_IN_MILLISECONDS } from 'config';
import {
  PublicStopeNoteApprovalViewDto,
  useGetPublicStopeNote
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { StopeNoteApprovalPageParams } from './constants';

export type StopeNoteApprovalPageQueries = [
  UseQueryResult<PublicStopeNoteApprovalViewDto>,
];

const useStopeNoteApprovalPageQueries = (params: StopeNoteApprovalPageParams): StopeNoteApprovalPageQueries => {
  const stopeNoteQuery = useGetPublicStopeNote(
    {
      mineModelId: params.projectId as string,
      stopeNoteId: params.stopeNoteId as string,
      token: params.accessToken as string,
    },
    { staleTime: HOUR_IN_MILLISECONDS },
  );

  return [stopeNoteQuery];
};

export default useStopeNoteApprovalPageQueries;
